import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { InsuranceApproval } from './insuranceApproval';
import { Document } from '@roc/feature-types';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type InsuranceApprovalDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
};

const useStyles = makeStyles(theme => ({
  dialogPadding: {
    '& .MuiDialogContent-root': {
      padding: '0 24px',
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: 0
    }
  }
}));

export const InsuranceApprovalDialog = observer(
  (props: InsuranceApprovalDialogProps) => {
    const { open, onClose, document } = props;
    const taskId = document?.taskId;
    const classes = useStyles();
    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            className={classes.dialogPadding}
            open={open}
            title="Insurance Summary"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<InsuranceApproval />}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            className={classes.dialogPadding}
            open={open}
            title="Insurance Summary"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<InsuranceApproval />}
          />
        )}
      </>
    );
  }
);

export default InsuranceApprovalDialog;
